export const ZOHO_PLUGIN_ID = "97911750-50d8-486b-b37e-00cffb65dead";
export const HTTP_PLUGIN_ID = "86be7e34-ed31-49b3-89e2-1550d6380f47";
export const SFTP_PLUGIN_ID = "9fbb12a0-b977-4efa-9349-83f308c6ff9d";

